import {
  CLEAR_STORE,
  REQUEST_LANGUAGE_SUCCEEDED,
  REQUEST_TRANSLATIONS,
  TOGGLE_CHAT_SOUND,
  TOGGLE_CHAT_TRANSLATE,
  CREATE_SYSTEM_MESSAGE
} from '../constants';

export const requestTranslations = () => ({ type: REQUEST_TRANSLATIONS });

export const requestLanguageSucceeded = (payload) => ({
  type: REQUEST_LANGUAGE_SUCCEEDED,
  payload
});

/**
 * @param {{ isSoundOn: boolean, isDistributed?: boolean}} params
 * @returns {{payload: { isSoundOn: boolean, isDistributed: boolean}, type: string}}
 */
export const toggleChatSound = ({ isSoundOn, isDistributed = false }) => ({
  type: TOGGLE_CHAT_SOUND,
  payload: {
    isSoundOn,
    isDistributed
  }
});

/**
 * @param {boolean} isTranslateActive
 * @returns {{payload: boolean, type: string}}
 */
export const toggleChatTranslate = (isTranslateActive) => ({
  type: TOGGLE_CHAT_TRANSLATE,
  payload: isTranslateActive
});

/** @returns {{type: string}} */
export const clearStore = () => ({ type: CLEAR_STORE });

/**
 * @typedef {Object} CreateSystemMessagePayload
 * @property { string } intlKey
 * @property { string } type
 * @property { Object } [intlValues]
 * @property { number } [timestamp]
 */

/**
 * @param {CreateSystemMessagePayload} payload
 * @returns {{payload: CreateSystemMessagePayload, type: string}}
 */
export const createSystemMessage = ({ intlKey, intlValues, timestamp, type }) => ({
  type: CREATE_SYSTEM_MESSAGE,
  payload: {
    intlKey,
    intlValues,
    type,
    timestamp: timestamp || +new Date()
  }
});
